import React from "react";
import { useLeague } from "../context/LeagueContext";

// Standardised "LEAGUE | Tab" title chip that lives in the site nav (nav bar 3)
// alongside a page's hoisted toggle controls. The league half reacts to the
// globally selected league (PWHL ↔ NCAA); the page half is fixed per tab.
export function NavPageTitle({ page, leagueOverride, count, testId = "nav-page-title" }) {
    const { isNcaa } = useLeague();
    const league = leagueOverride || (isNcaa ? "NCAA" : "PWHL");
    return (
        <span
            className="font-heading text-lg sm:text-xl uppercase tracking-tight leading-none mr-1.5 flex items-baseline gap-1.5"
            data-testid={testId}
        >
            <span className="font-bold text-white/45">{league}</span>
            <span className="font-black text-white">{page}</span>
            {count != null && <span className="font-mono-stat text-xs font-bold text-[#9D4CDD] tabular-nums" data-testid={`${testId}-count`}>· {count}</span>}
        </span>
    );
}

export default NavPageTitle;
